import { FIELDS } from '../../../shared/screener-constants';

const sanitizeConditions = conditions => {
  return conditions.map(condition => {
    condition.values = condition.values.map(value => value.toString());
    return condition;
  });
};

export const formatArgs = screenerArgs => {
  const args = [];
  /* arg object for forcing fixed annuities*/
  /* [{
    field: FIELDS.TCFUNDTYPE,
    conditions: [{ operator: 'Like', values: ['TIAA Fixed Annuity'] }]
  }]*/
  if (screenerArgs) {
    // eslint-disable-next-line array-callback-return
    Object.entries(screenerArgs).forEach(([field, value]) => {
      if (Object.values(FIELDS).includes(field)) {
        if (value !== -1) {
          const val = { field, conditions: sanitizeConditions(value) };
          args.push(val);
        }
      }
      return null;
    });
  }
  return args;
};

const formatScreenerInputs = (screenerArgs, fundTypeArgs, offset = 0) => {
  const args = formatArgs(screenerArgs);

  if (fundTypeArgs && Object.keys(fundTypeArgs).length !== 0) {
    args.push(fundTypeArgs);
  }

  const distributionsFields = [
    FIELDS.TCDISTRECORDDATEMONTHLY,
    FIELDS.TCDISTREINVESTPAYABLEDATEMONTHLY,
    FIELDS.TCDISTAMOUNTMONTHLY,
    FIELDS.TCDISTNAVMONTHLY,
    FIELDS.TCDISTRECORDDATEQRTLY,
    FIELDS.TCDISTREINVESTPAYABLEDATEQRTLY,
    FIELDS.TCDISTAMOUNTQRTLY,
    FIELDS.TCDISTNAVQTRLY,
    FIELDS.TCDISTRECORDDATEFYE,
    FIELDS.TCDISTREINVESTPAYABLEDATEFYE,
    FIELDS.TCDISTORDINCOMEFYE,
    FIELDS.TCDISTNAVANNUAL,
    FIELDS.TCPROJDISTNAV,
    FIELDS.TCTOTADISTRIBUTIONFYE,
    FIELDS.TCPROJDISTASOFDATE,
    FIELDS.TCPROJDISTTOTALGAIN,
    FIELDS.TCPROJDISTTOTALGAINNAVPCT,
    FIELDS.TCPROJDISTLONGTERMCAPGAIN,
    FIELDS.TCPROJDISTSHORTTERMCAPGAIN,
    FIELDS.TCPROJDISTEXPAYREINVESTDATE,
    FIELDS.TCPROJDISTRECORDDATE
  ];

  const fixedAnnuityFields = [
    FIELDS.TCRATERETURN1YR,
    FIELDS.TCRATERETURN3YR,
    FIELDS.TCRATERETURN5YR,
    FIELDS.TCRATERETURN10YR,
    FIELDS.TCRATERETURNSI,
    FIELDS.TCRATERETURNASOFDATE,
    FIELDS.TCRATERETURNQTR1YR,
    FIELDS.TCRATERETURNQTR3YR,
    FIELDS.TCRATERETURNQTR5YR,
    FIELDS.TCRATERETURNQTR10YR,
    FIELDS.TCRATERETURNQTRSI,
    FIELDS.TCRATERETURNQTRASOFDATE,
    FIELDS.TCGUARANTEEDMINIMUMRATE,
    FIELDS.TCCURRENTRATE,
    FIELDS.TCSVCURRENTRATE,
    FIELDS.TCSVGUARANTEEDMINIMUMRATE
  ];

  const fdicFields = [FIELDS.TCCURRENTAPY, FIELDS.TCCURRENTINTERESTRATE];

  const retirePlusFields = [FIELDS.TCAVGANNRETURNQTR3MO];

  const salesChargeFields = [
    FIELDS.TCAVGANNUALRTRN1MO_OFFER,
    FIELDS.TCAVGANNUALRTRN3MO_OFFER,
    FIELDS.TCAVGANNUALRTRN6MO_OFFER,
    FIELDS.TCAVGANNUALRTRNYTD_OFFER,
    FIELDS.TCAVGANNUALRTRN1YR_OFFER,
    FIELDS.TCAVGANNUALRTRN3YR_OFFER,
    FIELDS.TCAVGANNUALRTRN5YR_OFFER,
    FIELDS.TCAVGANNUALRTRN10YR_OFFER,
    FIELDS.TCAVGANNUALRTRNSINCEINC_OFFER,
    FIELDS.TCQAVGANNUALRTRN1MO_OFFER,
    FIELDS.TCQAVGANNUALRTRN3MO_OFFER,
    FIELDS.TCQAVGANNUALRTRN6MO_OFFER,
    FIELDS.TCQAVGANNUALRTRNYTD_OFFER,
    FIELDS.TCQAVGANNUALRTRN1YR_OFFER,
    FIELDS.TCQAVGANNUALRTRN3YR_OFFER,
    FIELDS.TCQAVGANNUALRTRN5YR_OFFER,
    FIELDS.TCQAVGANNUALRTRN10YR_OFFER,
    FIELDS.TCQAVGANNUALRTRNSINCEINC_OFFER
  ];

  return {
    argsOperator: 'AND',
    arguments: args,
    offset,
    limit: 500,
    resultFields: [
      FIELDS.ACTIVEDATE,
      FIELDS.ASSETCLASS,
      FIELDS.PERFORMANCEFILTER,
      FIELDS.PERFVSPEERSFILTER,
      FIELDS.MSTARRATINGOVERALL,
      FIELDS.TCMSTARRATINGASOFDATE,
      FIELDS.TCMSTARCATEGORY,
      FIELDS.TCWSODISSUE,
      FIELDS.TCTICKER,
      FIELDS.TCDERIVEDTICKER,
      FIELDS.TCTIAACREFID,
      FIELDS.TCTIAACUSIP,
      FIELDS.TCFUNDSHARECLASSID,
      FIELDS.TCINVESTMENTNAME,
      FIELDS.TCFUNDTYPE,
      FIELDS.TCSHARECLASS,
      FIELDS.MSTARBONDBOXFILTER,
      FIELDS.MSTAREQUITYBOXFILTER,
      FIELDS.PRODUCTTYPE,
      FIELDS.DAILYYTDFILTER,
      FIELDS.EXPENSEFILTER,
      FIELDS.YIELDFILTER,
      FIELDS.RISKFILTER,
      FIELDS.RISKVSPEERS,
      FIELDS.PERFVSPEERSFILTER,
      FIELDS.TCINCEPTIONDATE,
      FIELDS.TCAVGANNRETURN1YR,
      FIELDS.TCAVGANNRETURN3YR,
      FIELDS.TCAVGANNRETURN5YR,
      FIELDS.TCAVGANNRETURN10YR,
      FIELDS.TCAVGANNRETURNASOFDATE,
      FIELDS.TCAVGANNRETURNSI,
      FIELDS.TCEXPIRATIONDATE,
      FIELDS.TCFUNDNAV,
      FIELDS.TCFUNDNAVASOFDATE,
      FIELDS.TCFUNDNAV1DAYCHANGE,
      FIELDS.TCFUNDNAV1DAYPCTCHANGE,
      FIELDS.TCFUNDNAVYTDPCTCHANGE,
      FIELDS.TCNETEXPENSES,
      FIELDS.TCGROSSEXPENSE,
      FIELDS.TCNETEXPENSESFILTERPTILETANK,
      FIELDS.TCAVGANNRETURNQTR1YR,
      FIELDS.TCAVGANNRETURNQTR3YR,
      FIELDS.TCAVGANNRETURNQTR5YR,
      FIELDS.TCAVGANNRETURNQTR10YR,
      FIELDS.TCAVGANNRETURNQTRASOFDATE,
      FIELDS.TCAVGANNRETURNQTRYTD,
      FIELDS.TCAVGANNRETURNYTD,
      FIELDS.TCAVGANNRETURNQTRSI,
      FIELDS.TCMMNYMKTEFFECTIVEYIELD7DAY,
      FIELDS.TCYIELDASOFDATE,
      FIELDS.TCOVERALLRATINGOUFOFNUMBER,
      FIELDS.TCUNDERLYINGFUNDINCEPTIONDATE,
      FIELDS.TCMNYMKTAVGANNUALYIELD7DAY,
      FIELDS.TCMNYMKTAVGANNUALYIELD30DAY,
      FIELDS.TCMMNYMKTEFFECTIVEYIELD7DAY,
      FIELDS.TCSECYIELD,
      FIELDS.TCSECYIELDUNSUB,
      FIELDS.TCISLINKEDPERF1YR,
      FIELDS.TCISLINKEDPERF3YR,
      FIELDS.TCISLINKEDPERF5YR,
      FIELDS.TCISLINKEDPERF10YR,
      FIELDS.TCISLINKEDPERFQTR1YR,
      FIELDS.TCISLINKEDPERFQTR3YR,
      FIELDS.TCISLINKEDPERFQTR5YR,
      FIELDS.TCISLINKEDPERFQTR10YR,
      FIELDS.TCSTARTDATE,
      FIELDS.TCISTIAACREFFUND,
      FIELDS.TCTREATASPROP,
      FIELDS.TCSHORTTERMCAPGAINSFYE,
      FIELDS.TCLONGTERMCAPGAINSFYE,
      FIELDS.TCTRANSFERLIMITTYPECODE,
      FIELDS.TCNUMBEROFDAYS,
      FIELDS.TCDAYSBLOCKED,
      ...distributionsFields,
      ...fixedAnnuityFields,
      ...fdicFields,
      ...retirePlusFields,
      ...salesChargeFields
    ],
    sortArguments: [
      {
        direction: 'A',
        field: 'TCFundType'
      },
      {
        direction: 'A',
        field: 'TCBestReturn3YrPtileRank'
      }
    ]
  };
};

export default formatScreenerInputs;
